import { request } from '../../utils'

export const updateLive = (liveId, data = {}) => {
  return request({
    url: '/api/live/update',
    data: {
      ...data,
      live_format: 'webinar',
      live_id: liveId,
    },
  })
}

export const fetchLive = (liveId, token) => {
  return request({
    url: '/api/live/list',
    method: 'GET',
    data: {
      ...(token ? { token } : {}),
      live_format: 'webinar',
      live_id: liveId,
    },
  })
}
